var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
import { useJSPositioning } from '#hooks';
// 18px since arrow width and height are 14px + 4px offset according to Figma(ds-gap-xs)
const TOOLTIP_OFFSET = 18;
/**
 * @param {Side} placement - One of four available sides defined by FloatingUI
 * @return
 *      isTooltipActive(boolean) - determine whether the Tooltip Component should be rendered.
 *      tooltipProps - add them to Tooltip component as tooltipProps - Tooltip will do the according spread to elements.
 *      triggerProps - spread them in the desired trigger element - they contain a ref and tabIndex if necessary.
 */
export const useTooltip = ({ fallbackAxisSideDirection, placement, strategy } = {
    placement: 'bottom',
}) => {
    _react_refresh_temp_1();
    const [isTooltipActive, setIsTooltipActive] = useState(false);
    const { anchorRef, arrowProps, refs, targetProps, triggerProps } = useJSPositioning({
        open: isTooltipActive,
        onOpenChange: setIsTooltipActive,
        shouldToggleWhenFocused: true,
        hasArrow: true,
        contentOffset: TOOLTIP_OFFSET,
        ...(placement && { placement }),
        fallbackAxisSideDirection,
        ...(strategy && { strategy }),
    });
    return {
        isTooltipActive,
        tooltipProps: {
            targetProps,
            arrowProps,
        },
        triggerProps,
        anchorRef,
        refs,
    };
};
_react_refresh_temp_1(useTooltip, "omK7RWxIroB/W0M9otOLn4YsMTs=", false, () => [useJSPositioning]);
